import BillingsOrderForwardRelatedTaxiDriver, {
  BillingsOrderForwardRelatedTaxiDriverItem,
  BillingsOrderForwardRelatedTaxiDriverItemContractDetails,
} from "./billings-order-forward-related-taxi-driver";
import BillingsOrderForwardRelatedTaxiDriverResponse, {
  BillingsOrderForwardRelatedTaxiDriverResponseItem,
  BillingsOrderForwardRelatedTaxiDriverResponseItemContract,
  BillingsOrderForwardRelatedTaxiDriverResponseItemContractBillingModel,
} from "../../../../../api/raily/billings/order-forward/related/taxi-driver/billings-order-forward-related-taxi-driver.response";
import BillingModel from "../../../../../types/billing-model";

const createDataItemBillingModel = (
  billingModel: BillingsOrderForwardRelatedTaxiDriverResponseItemContractBillingModel,
): BillingModel => {
  switch (billingModel) {
    case BillingsOrderForwardRelatedTaxiDriverResponseItemContractBillingModel.AB:
      return BillingModel.AB;
    case BillingsOrderForwardRelatedTaxiDriverResponseItemContractBillingModel.ABA:
      return BillingModel.ABA;
    case BillingsOrderForwardRelatedTaxiDriverResponseItemContractBillingModel.OTHER:
      return BillingModel.OTHER;
    case BillingsOrderForwardRelatedTaxiDriverResponseItemContractBillingModel.SABS:
      return BillingModel.SABS;
  }
};

const createDataItemContractDetails = (
  contractDetails: BillingsOrderForwardRelatedTaxiDriverResponseItemContract,
): BillingsOrderForwardRelatedTaxiDriverItemContractDetails => {
  return {
    companyName:
      contractDetails.taxiDriverAssociation.taxiCorporation.displayName,
    distanceRate: contractDetails.distanceRate,
    model: createDataItemBillingModel(contractDetails.model),
  };
};

const createDataItem = (
  data: BillingsOrderForwardRelatedTaxiDriverResponseItem,
): BillingsOrderForwardRelatedTaxiDriverItem => {
  return {
    billingUuid: data.id,
    contractDetails: createDataItemContractDetails(data.contract),
    amountForChargeHaltings: data.amountForChargeHaltings,
    amountForChargeHighways: data.amountForChargeHighways,
    distance: data.distance,
    amountForDistance: data.amountForDistance,
    internalOrderId: data.planEntry.humanId,
    allContributionsAmount: data.allContributionsAmount,
    isDraft: data.draft,
    date: data.date,
    sumOfBonuses: data.sumOfBonuses,
    sumOfPenalties: data.sumOfPenalties,
  };
};

const createData = (
  responseData: BillingsOrderForwardRelatedTaxiDriverResponseItem[],
): BillingsOrderForwardRelatedTaxiDriverItem[] => {
  return responseData.map(createDataItem);
};

const create = (
  response: BillingsOrderForwardRelatedTaxiDriverResponse,
): BillingsOrderForwardRelatedTaxiDriver => {
  return {
    data: createData(response.data),
  };
};

const billingsOrderForwardRelatedTaxiDriverFactory = {
  create,
};

export default billingsOrderForwardRelatedTaxiDriverFactory;
